import React from "react";
import PropTypes from "prop-types";
import { hexToRGBA } from "../../../Common/Utils/ThemeManager";
import "./styles.scss";

const UserMessage = ({ content, className = "", themeColor }) => {
  const bgColor = hexToRGBA(themeColor, 0.08); // 8% opacity for very subtle background
  const borderColor = hexToRGBA(themeColor, 0.15); // 15% opacity for border

  return (
    <div className={`user-message-container ${className}`} style={{
      margin: "24px 0",
      display: "flex",
      justifyContent: "flex-end",
      animation: "fadeInMessage 0.3s ease",
    }}>
      {/* Message Content - Right aligned */}
      <div style={{
        maxWidth: "70%",
        lineHeight: "1.6",
        backgroundColor: bgColor,
        padding: "14px 18px",
        borderRadius: "12px",
        border: `1px solid ${borderColor}`,
      }}>
        <p style={{
          margin: 0,
          fontSize: "15px",
          color: "#334155", // Slightly softer than AI messages
          fontWeight: "500", // Slightly bolder for user messages
        }}>{content}</p>
      </div>
    </div>
  );
};

UserMessage.propTypes = {
  content: PropTypes.string.isRequired,
  className: PropTypes.string,
  themeColor: PropTypes.string,
};

export default UserMessage;
